import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";

// Get the financial year string for a given date
const getFinancialYear = (dateStr) => {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = date.getMonth();
  const fyStart = month >= 3 ? year : year - 1;
  return `FY ${fyStart}-${fyStart + 1}`;
};

// Get unique financial years from project list, sorted descending
const getFinancialYears = (projects, includePreviousFY = false) => {
  const fySet = new Set();
  let minFYYear = new Date().getFullYear();

  projects.forEach((p) => {
    const date = new Date(p.start_date);
    const year = date.getFullYear();
    const month = date.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    const fyLabel = `FY ${fyStart}-${fyStart + 1}`;

    fySet.add(fyLabel);
    if (fyStart < minFYYear) {
      minFYYear = fyStart;
    }
  });

  if (includePreviousFY) {
    fySet.add(`FY ${minFYYear - 1}-${minFYYear}`);
  }

  return [...fySet].sort((a, b) => {
    const aStart = +a.split(" ")[1].split("-")[0];
    const bStart = +b.split(" ")[1].split("-")[0];
    return bStart - aStart;
  });
};

const GroupProjectsPieChart = ({ projects }) => {
  const financialYears = getFinancialYears(projects);
  const currentFY = getFinancialYear(new Date());
  const [selectedFY, setSelectedFY] = useState(currentFY);

  // Filter projects by selected financial year
  const filteredProjects = selectedFY
    ? projects.filter((p) => getFinancialYear(p.start_date) === selectedFY)
    : projects;

  const groupCounts = filteredProjects.reduce((acc, project) => {
    project.associated_groups.forEach((group) => {
      acc[group] = (acc[group] || 0) + 1;
    });
    return acc;
  }, {});

  const generateColor = (index) => {
    const baseColors = ["#74CB80", "#FF7BD7", "#F56B62", "#197FC7", "#56B6FC"];
    if (index < baseColors.length) return baseColors[index];
    const hueShift = (index * 137) % 360;
    return `hsl(${hueShift}, 60%, 65%)`;
  };

  const groupNames = Object.keys(groupCounts);
  const chartData = groupNames.map((group, index) => ({
    name: group,
    value: groupCounts[group],
    itemStyle: { color: generateColor(index) },
  }));

  const option = {
    title: {
      // text: selectedFY || "All Projects",
      left: "center",
      textStyle: {
        fontSize: 18,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} projects ({d}%)",
    },
    legend: {
      orient: "vertical",
      bottom: "10px",
      right: "right",
    },
    series: [
      {
        name: "Projects",
        type: "pie",
        radius: "80%",
        data: chartData,
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  return (
    <div className="project-status">
      <h2 className="pie-header">Projects by Associated Groups</h2>
      <select
        className="pm-fy-dd"
        value={selectedFY}
        onChange={(e) => setSelectedFY(e.target.value)}
      >
        <option value="">All Years</option>
        {financialYears.map((fy) => (
          <option key={fy} value={fy}>
            {fy}
          </option>
        ))}
      </select>
      <ReactECharts
        className="pie-chart"
        option={option}
        style={{ height: "400px" }}
      />
    </div>
  );
};

export default GroupProjectsPieChart;
